import React,{Component} from 'react'
import {getWorkers} from '../requests/workers'
import Loading from '../components/Loading'
import moment from 'moment'
import utils from '../utils/utils'

export default class Worker extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      rows: [],
      selectedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
      loading: false
    }
  }
  componentWillMount () {
    this.loadWorkers()
  }

  async loadWorkers(){
    this.setState({loading:true})
    let data = await getWorkers()
    console.log(data)
    this.setState({loading:false, rows: data.workers})
  }
  // getLoadStyles(value){
  //   value = Number(value)
  //   return (value >= 80) ? 'danger' : (value >= 60 && value< 80) ? 'warning' : 'success'
  // }
  render(){
    if (this.state.loading) {
      return (<Loading/>)
    }
    let deltaTime = Number(10  * 60 * 1000)
    const rows = this.state.rows.map((item) => {
      // let style = (item.status === 'DONE') ? 'success' : (item.status === 'ERROR') ? 'danger' : (item.status === 'STARTED') ? 'warning' : ''
      let pollingStyle = (item.status === 'POLLING') ? 'ok online' : 'remove offline'
      let onlineTime = new Date().getTime() - deltaTime
      let styleOnlie = (item.notified > onlineTime) ? 'circle-arrow-up online' : 'circle-arrow-down offline'
      let momentDuration = moment.duration(Number(new Date().getTime()) - Number(item.started))
      let jobsStyle = (item.jobs_running > 0) ? 'info': ''
      // console.log('momentDuration->',momentDuration)
      return (
      <tr key = {item.instance_id}>
        {/* <td className={style}>{item.status}</td> */}
        <td>{item.server_ip}</td>
        <td>{item.instance_id}</td>
        <td>{item.zone}</td>
        <td>{item.worker_type}</td>
        <td className={utils.getLoadStyles(item.avg_load)}>{item.avg_load}%</td>
        <td className={utils.getLoadStyles(item.network)}>{item.network}%</td>
        <td className ={utils.getLoadStyles(item.storage)}>{item.storage}%</td>
        <td className ={utils.getLoadStyles(item.load_units)}>{item.load_units}%</td>
        <td className={jobsStyle}>{item.jobs_running}</td>
        <td><span className={`glyphicon glyphicon-${styleOnlie}`} aria-hidden="true"></span></td>
        <td>{item.version}</td>
        <td> <span className={`glyphicon glyphicon-${pollingStyle}`} aria-hidden="true"></span></td>
        <td>{`${momentDuration.get("d")} days ${momentDuration.get("h")} hours`}</td>
      </tr> )
    })
    return(
      <div>
        <h1 className='loading'>Workers ({this.state.rows.length}) </h1>
        <table className='table table-hover table-bordered table-ms'>
          <thead>
            <tr className='active'>
              <th>Server</th>
              <th>Instance</th>
              <th>Zone</th>
              <th>Type</th>
              <th>Avg Load</th>
              <th>Network</th>
              <th>Storage</th>
              <th>Load Unit</th>
              <th>Jobs</th>
              <th>Status</th>
              <th>Version</th>
              <th>Polling</th>
              <th>Running</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Workers.js